import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Caja } from './caja';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CajaService {


  constructor(private http: HttpClient) { }


  eliminar(id) {
    return this.http.delete<void>(environment.apiUrl + "/eliminarCierreCaja/?id=" + id);
  }
  aperturaCaja(caja: Caja) {

    return this.http.put<string>(environment.apiUrl + "/actualizarCierreCaja", caja);
  }
  cerraCaja(caja: Caja) {

    return this.http.put<string>(environment.apiUrl + "/actualizarCierre", caja);
  }

  
  listaCaja(idEmisor, usuario) {
    return this.http.get<Caja[]>(environment.apiUrl + "/listaCierreCaja/?idEmisor=" + idEmisor + "&usuario=" + usuario);


  }



  validarCajaHabiertaFacturacion(idEmisor, usuario, caja) {
    return this.http.get<Caja[]>(environment.apiUrl + "/validarCajaHabiertaFacturacion/?id=" + idEmisor + "&usuario=" + usuario + "&caja=" + caja);
  }


  validarCajaCerradaFacturacion(idEmisor, usuario, caja) {
    return this.http.get<Caja[]>(environment.apiUrl + "/validarCajaCerradaFacturacion/?id=" + idEmisor + "&usuario=" + usuario + "&caja=" + caja);
  }



}
